import { Directive, Host } from '@angular/core';
import { DataTableNewComponent } from '../data-table-new.component';

@Directive({ selector: '[vfsDatatableActions]', exportAs: 'vfsDatatableActions' })
export class DatatableActionsDirective {
  constructor(@Host() private parent: DataTableNewComponent<any>) {
    this.parent.withActions = true;
  }
}
